import { IconContainer } from "../../Buttons/IconContainer"
import { UnderlinedButton } from "../../Buttons/UnderlinedButton"
import ArrowLeft from "../../../public/images/icons/arrow_left.svg";

export const PrevButton = ({ onPrev, className, ...rest }: any) => {
    return (
        <UnderlinedButton className={className} onClick={onPrev} {...rest}>
            <IconContainer responsiveText={false} icon={<ArrowLeft className="w-8 h-8 text-white" />} label="Back" />
        </UnderlinedButton>
    )
}